<template>
  <div class="awl-confirm">
    <button @click.prevent="showModal" class="btn" :class="'btn-' + status">
      <template v-if="!iconClass">
        {{title}}
      </template>
      <template v-else>
        <i :class="iconClass"></i>
      </template>
    </button>
    <BModal dialog-class="modal--type-dialog" :id="id" :ref="id" centered scrollable>
      <template slot="modal-title">
        <slot name="title">{{modalTitle}}</slot>
      </template>
      <template slot="modal-header-close">
        <i class="fas fa-times"></i>
      </template>
      <div class="d-block">
        <slot>Sei sicuro?</slot>
      </div>
      <template #modal-footer>
        <button class="ml-2 btn btn-outline-danger" @click="close(false)">{{ koLabel }}</button>
        <button class="btn btn-primary" @click="close(true)">{{ okLabel }}</button>
      </template>
    </BModal>
  </div>
</template>

<script>
import { BModal } from 'bootstrap-vue';

export default {
  name: 'awl-confirm',
  components: {
    BModal,
  },
  props: {
    status: {
      type: String,
      default: 'primary',
    },
    title: {
      type: String,
    },
    iconClass: {
      type: String,
    },
  },
  data () {
    return {
      modalTitle: 'Richiesta di Conferma',
      okLabel: 'Conferma',
      koLabel: 'Annulla',
      id: 'modal-' + (Math.floor(Math.random() * 1000000)).toString().padStart(7, '0'),
    };
  },
  methods: {
    showModal () {
      this.$refs[this.id].show();
      this.$emit('open');
    },
    close (status = false) {
      if (status) {
        this.$emit('confirm', status);
      }

      this.$refs[this.id].hide();
    },
  },
};
</script>

<style lang="scss">
.awl-confirm {
  display: inline-block;
}
.modal-header {
  .close {
    background: none;
    border: none;
    box-shadow: none;
  }
}
.modal-backdrop {
  opacity: 0.5;
}
</style>
